export function addImpression(timelineId) {
    $.ajax({
        type: "POST",
        url: "/module/community/ajax.php?action=add_impression",
        datatype: "json",
        data: {
            "ajax_call_timeline_id": timelineId
        }
    });
}